module.exports = __webpack_public_path__ + "img/logo1.6f56ae97.png";